import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AangifteSchenkbelasting,
  GiftTaxEntity,
  Persoon
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {BokkzAlgDataService, BokkzSbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {Subscription} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-schenker',
  standalone: true,
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule
  ],
  templateUrl: './schenker.component.html',
  styleUrl: './schenker.component.css'
})
export class SchenkerComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private giftTaxEntitySubscription: Subscription | undefined;
  public giftTaxEntity = {} as GiftTaxEntity;
  public sbAangifte = {} as AangifteSchenkbelasting;
  public persoonFg = {} as FormGroup;
  public beconNummer: string | undefined;
  public focusedElementId: string | null = null;

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzSbDataService,
    private fb: FormBuilder) {
    this.persoonFg = this.fb.group<Persoon>({
      roepnaam: null as unknown as string,
      voorletters: null as unknown as string,
      tussenvoegsels: null as unknown as string,
      achternaam: null as unknown as string,
      bsn: null as unknown as string,
      geboortedatum: null as unknown as Date,
      overlijdensdatum: null as unknown as Date,
      landCodeNationaliteit: null as unknown as string,
    })
  }

  ngOnInit(): void {
    this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((giftTaxEntity) => {
      const aangifte= giftTaxEntity.aangifte
      this.giftTaxEntity = giftTaxEntity;
      if (aangifte) {
        this.sbAangifte = aangifte;
        this.persoonFg.patchValue(aangifte.schenker, {emitEvent: false})
      }
    })
  }

  ngOnDestroy(): void {
    if (this.giftTaxEntitySubscription) {
      this.giftTaxEntitySubscription.unsubscribe()
    }
  }

  saveForm(): void {
    this.persoonFg.updateValueAndValidity({ emitEvent: false });
    setTimeout(() => {
      this.giftTaxEntity.aangifte = {
        ...this.sbAangifte,
        aangever: {
          ...this.sbAangifte.aangever,
          roepnaam: this.persoonFg.value.roepnaam,
          voorletters: this.persoonFg.value.voorletters,
          tussenvoegsels: this.persoonFg.value.tussenvoegsels,
          achternaam: this.persoonFg.value.achternaam,
          bsn: this.persoonFg.value.bsn,
          geboortedatum: this.persoonFg.value.geboortedatum,
          overlijdensdatum: this.persoonFg.value.overlijdensdatum,
          landCodeNationaliteit: this.persoonFg.value.landCodeNationaliteit,
        },
        schenker: {
          ...this.sbAangifte.schenker,
          roepnaam: this.persoonFg.value.roepnaam,
          voorletters: this.persoonFg.value.voorletters,
          tussenvoegsels: this.persoonFg.value.tussenvoegsels,
          achternaam: this.persoonFg.value.achternaam,
          bsn: this.persoonFg.value.bsn,
          geboortedatum: this.persoonFg.value.geboortedatum,
          overlijdensdatum: this.persoonFg.value.overlijdensdatum,
          landCodeNationaliteit: this.persoonFg.value.landCodeNationaliteit,
        },
      } as AangifteSchenkbelasting;
      this.dataService.updateGiftTaxEntity(this.giftTaxEntity);
    }, 0)
  }
}
